var styles = {"container":"OverlayPortal-module_container__8epFx","containerRight":"OverlayPortal-module_containerRight__50iuy","containerLeft":"OverlayPortal-module_containerLeft__KiArz","trap":"OverlayPortal-module_trap__rvrbV"};

export { styles as default };
